module.exports = __webpack_public_path__ + "static/13-3f6d2d6fb8c92d7f3aa129a0b880bd41.jpg";